var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tag-cloud-widget',{staticClass:"box-height-100",attrs:{"title":_vm.title,"words":_vm.words,"max-value":_vm.maxBy.value}})}
var staticRenderFns = []

export { render, staticRenderFns }